import React, { useEffect, useState } from "react";
import InputText from "../ReusableComponents/InputText";
import { mainTable } from "../css/Common";
import AddScreenTitle from "../components/AddScreenTitle";
import MainLayout from "../components/MainLayout";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import Buttons from "../components/Buttons";
import GridPage from "../components/GridPage";
import { AttendanceHeader } from "../components/HeaderAttribute";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import MainPopup from "../popup-containers/MainPopup";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import toast from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import Attendancepopup from "../popup-containers/Attendancepopup";
import DropDown from "../ReusableComponents/DropDown";
import Loader from "../ReusableComponents/Loader";

const Attendance = () => {
  const [addScreenTitle, setAddScreenTitle] = useState(true);
  const [isDuplicate, setIsDuplicate] = useState(false);
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState(null);
  const [bindSalaryPaidGridDatas, setbindSalaryPaidGridDatas] = useState([]);
  const [bindAttendance, setbindAttendance] = useState([]);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [staffNameDD, setStaffNameDD] = useState([]);
  const [shiftDD, setShiftDD] = useState([]);
  const [statusOptions, setstatusOptions] = useState([]);
  const [designationOptions, setdesignationOptions] = useState([]);
  const [permissionTypeOptions, setpermissionTypeOptions] = useState([]);
  const [permissiondurationOptions, setpermissiondurationOptions] = useState([]);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [popupDataDD, setPopupDataDD] = useState([]);
  const [MstAttendanceId, setMstAttendanceId] = useState(0);
  const [editMode, setEditMode] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  const [formFieldsError, setFormFieldsError] = useState({
    staffNameError: "",
    salaryDateError: "",
    designationError: "",
    statusError: "",
    permissiontypeError: "",
    permissiondurationError: "",
    forenoonInTimeError: "",
    forenoonOutTimeError: "",
    afternoonInTimeError: "",
    afternoonOutTimeError: "",
    remarksForenoonError: "",
    remarksAfternoonError: "",
  });

  const [formFields, setFormFields] = useState({
    staffName: "",
    salaryDate: "",
    position: "",
    shift: "",
    status: "",
    permissiontype: "",
    permissionduration: "",
    forenoonInTime: "",
    forenoonOutTime: "",
    afternoonInTime: "",
    afternoonOutTime: "",
    remarksForenoon: "",
    remarksAfternoon: "",
    totalHours: "",
  });

  const createdBy = sessionStorage.getItem("createdBy");
  var mstClientId = sessionStorage.getItem("MstClientId");

  // Calculate total hours whenever time fields change
  useEffect(() => {
    const calculateTotalHours = () => {
      const { forenoonInTime, forenoonOutTime, afternoonInTime, afternoonOutTime } = formFields;

      let totalMinutes = 0;

      // Helper function to convert time string (HH:MM) to minutes
      const timeToMinutes = (time) => {
        if (!time) return 0;
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes;
      };

      // Calculate forenoon duration
      if (forenoonInTime && forenoonOutTime) {
        const forenoonMinutes = timeToMinutes(forenoonOutTime) - timeToMinutes(forenoonInTime);
        if (forenoonMinutes > 0) {
          totalMinutes += forenoonMinutes;
        }
      }

      // Calculate afternoon duration
      if (afternoonInTime && afternoonOutTime) {
        const afternoonMinutes = timeToMinutes(afternoonOutTime) - timeToMinutes(afternoonInTime);
        if (afternoonMinutes > 0) {
          totalMinutes += afternoonMinutes;
        }
      }

      // Convert total minutes to hours with 2 decimal places
      const totalHours = (totalMinutes / 60).toFixed(2);
      setFormFields((prev) => ({ ...prev, totalHours }));
    };

    calculateTotalHours();
  }, [formFields.forenoonInTime, formFields.forenoonOutTime, formFields.afternoonInTime, formFields.afternoonOutTime]);

  useEffect(() => {
    BindAttendance();
  }, []);

  const BindAttendance = async () => {
    const data = {
      mstClientId: mstClientId,
    };

    const response = await BindPostAPI(data, "AttendanceAPI/BindAttendance");
    console.log("API Response:", response);

    if (response && response.data) {
      setbindSalaryPaidGridDatas(response.data.Table);

      const StaffNameData = response.data.Table1.map((item) => ({
        value: item.MstStaffId,
        label: item.StaffName,
        shiftId: item.MstShiftId,
        // positionId: item.MstPositionId,   
        position: item.Position       
      }));
      setStaffNameDD(StaffNameData);
      // const DesignationData = response.data.Table2.map((item) => ({
      //   value: item.MstDesignationId,
      //   label: item.Designation,
      // }));
      // setdesignationOptions(DesignationData);

      const shiftNameData = response.data.Table1.map((item) => ({
        value: item.MstShiftId,
        label: item.ShiftName,
      }));
      setShiftDD(shiftNameData);

      const StatusData = response.data.Table3.map((item) => ({
        value: item.MstStatusId,
        label: item.Status,
      }));
      setstatusOptions(StatusData);

      const PermissiontypeData = response.data.Table4.map((item) => ({
        value: item.MstPermissionId,
        label: item.Permissiontype,
      }));
      setpermissionTypeOptions(PermissiontypeData);

      const PermissiondurationData = response.data.Table5.map((item) => ({
        value: item.MstPermissiondurationId,
        label: item.Permissionduration,
      }));
      setpermissiondurationOptions(PermissiondurationData);
    } else {
      setbindAttendance([]);
    }
  };

  const fieldLabels = {
    staffName: "Staff",
    shift: "Shift",
    salaryDate: "Date",
    designation: "Designation",
    status: "Status",
    permissiontype: "Permission Type",
    permissionduration: "Permission Duration",
    forenoonInTime: "Forenoon In Time",
    forenoonOutTime: "Forenoon Out Time",
    afternoonInTime: "Afternoon In Time",
    afternoonOutTime: "Afternoon Out Time",
    remarksForenoon: "Forenoon Remarks",
    remarksAfternoon: "Afternoon Remarks",
  };
  const handleStaffChange = (value, e) => {
    const selectedStaff = staffNameDD.find((x) => x.value === value.value);
  
    // ✅ Duplicate check: Staff + Date
    const isAlreadySubmitted = bindSalaryPaidGridDatas.some(
      (record) =>
        record.MstStaffId === selectedStaff?.value &&
        record.Date?.split("T")[0] === formFields.salaryDate
    );
  
    if (isAlreadySubmitted) {
      setIsDuplicate(true);
      setFormFields((prev) => ({
        ...prev,
        staffName: ""   
      }));
      setFormFieldsError((prev) => ({
        ...prev,
        staffNameError: "Attendance already submitted for this staff on this date",
      }));
      return; // stop here (keep your previous logic intact below)
    }
  
    // ⬇️ keep your previous handleStaffChange logic exactly as it was
    setIsDuplicate(false);
  
    setFormFields((prev) => ({
      ...prev,
      staffName: selectedStaff?.value || "",
      shift: selectedStaff?.shiftId || "",
      position: selectedStaff?.position || "",
    }));
  
    setFormFieldsError((prevErrors) => ({
      ...prevErrors,
      staffNameError: selectedStaff ? "" : "Select Staff",
      shiftError: selectedStaff?.shiftId ? "" : "Select Shift",
      positionError: "",
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    setFormFields((prev) => {
      let updatedFields = { ...prev, [name]: value };
  
      // ✅ if status changes & it's not "Permission", clear permission fields
      if (name === "status") {
        const selectedStatus = statusOptions.find(
          (s) => s.value.toString() === value
        );
  
        if (!selectedStatus || selectedStatus.label.toLowerCase() !== "permission") {
          updatedFields.permissiontype = "";
          updatedFields.permissionduration = "";
        }
      }
  
      return updatedFields;
    });
  
    // ✅ clear error if valid, or set error if empty
    setFormFieldsError((prevErrors) => ({
      ...prevErrors,
      [`${name}Error`]: value ? "" : `Select ${fieldLabels[name]}`,
    }));
  };

  const handleBlur = (e) => {
    const { name, value, type } = e.target;
    let error = "";

    // List of mandatory fields
    const mandatoryFields = [
      "staffName",
      "salaryDate",
      "shift",
      "designation",
      "status"
      // "forenoonInTime",
      // "forenoonOutTime",
      // "afternoonInTime",
      // "afternoonOutTime",
    ];

    // Only validate mandatory fields
    if (mandatoryFields.includes(name)) {
      if (type === "select-one") {
        if (!value || value === "0" || value === "") {
          error = `Select ${fieldLabels[name]}`;
        }
      } else if (!value.trim()) {
        error = `Enter ${fieldLabels[name]}`;
      }
    }

    setFormFieldsError((prevErrors) => ({
      ...prevErrors,
      [`${name}Error`]: error,
    }));

  };


 const validateForm = () => {
  const newErrors = {};
  let isValid = true;

  // always required fields
  if (!formFields.staffName) {
    newErrors.staffNameError = "Select Staff";
    isValid = false;
  }
  if (!formFields.salaryDate) {
    newErrors.salaryDateError = "Select Date";
    isValid = false;
  }
  if (!formFields.status) {
    newErrors.statusError = "Select Status";
    isValid = false;
  }

  const selectedStatus = statusOptions.find(
    (s) => s.value.toString() === formFields.status
  );

  // ✅ special case: if Absent → forenoon & afternoon must be empty
  if (selectedStatus && selectedStatus.label.toLowerCase() === "absent") {
    if (
      formFields.forenoonInTime ||
      formFields.forenoonOutTime ||
      formFields.afternoonInTime ||
      formFields.afternoonOutTime ||
      formFields.remarksForenoon ||
      formFields.remarksAfternoon
    ) {
      newErrors.forenoonInTimeError =
        "For Absent, all forenoon and afternoon fields must be empty";
      isValid = false;
    }

    setFormFieldsError(newErrors);
    return isValid; // stop further checks
  }

  // ✅ existing logic for other statuses
  const requiredFields = [
    // { field: "shift", type: "select-one" },
    { field: "position", type: "text" },
  ];

  requiredFields.forEach(({ field, type }) => {
    const value = formFields[field];
    let isEmpty = false;

    if (type === "select-one") {
      isEmpty = !value || value === "0" || value === "";
    } else {
      isEmpty = !value || value.toString().trim() === "";
    }

    if (isEmpty) {
      newErrors[`${field}Error`] =
        type === "select-one"
          ? `Select ${fieldLabels[field]}`
          : `Enter ${fieldLabels[field]}`;
      isValid = false;
    }
  });

  // at least one in-time (unless absent handled above)
  if (!formFields.forenoonInTime && !formFields.afternoonInTime) {
    newErrors.forenoonInTimeError =
      "Enter at least Forenoon In Time or Afternoon In Time";
    newErrors.afternoonInTimeError =
      "Enter at least Forenoon In Time or Afternoon In Time";
    isValid = false;
  }

  // conditional: if status = Permission → enforce type & duration
  if (selectedStatus && selectedStatus.label.toLowerCase() === "permission") {
    if (!formFields.permissiontype) {
      newErrors.permissiontypeError = "Select Permission Type";
      isValid = false;
    }
    if (!formFields.permissionduration) {
      newErrors.permissiondurationError = "Select Permission Duration";
      isValid = false;
    }
  }

  setFormFieldsError(newErrors);
  return isValid;
};


  useEffect(() => {
    const currentDate = new Date().toISOString().split("T")[0]; // YYYY-MM-DD
    setFormFields((prev) => ({ ...prev, salaryDate: currentDate }));
  }, []);

  const formatTime = (time) => {
    if (!time) return null; // avoid invalid time
    const date = new Date(`1970-01-01T${time}`);
    return date.toISOString().split("T")[1].slice(0, 5); // HH:mm
  };

  // const combineDateTime = (date, time) => {
  //   if (!date || !time) return null;
  //   const fullDateTime = new Date(`${date}T${time}`);
  //   return isNaN(fullDateTime.getTime()) ? null : fullDateTime.toISOString();
  // };

  const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

  const Mintime = `${currentDate}T${formFields.forenoonInTime}`
  const Mouttime = `${currentDate}T${formFields.forenoonOutTime}`
  const Aintime = `${currentDate}T${formFields.afternoonInTime}`
  const Aouttime = `${currentDate}T${formFields.afternoonOutTime}`

  const formatDate = (value) => {
    if (!value) return null; // avoid empty string
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date.toISOString();
  };

  const handleSubmit = async (rowIndex, flag) => {

      ;
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const isValid = validateForm();
    if (flag == 1 || flag == 2) {
      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
      if (isValid) {
        setIsOpen(false);
        setIsLoading(true);
        const buildDateTime = (time) => {
          if (!time) return null; // if user didn’t select → null
          return `${currentDate}T${time}`;
        };
        
        const data = {
          MstAttendanceId: MstAttendanceId ? MstAttendanceId : 0,
          MstClientId: mstClientId,
          Date: formFields.salaryDate,
          MstStaffId: parseInt(formFields.staffName),
          MstShiftId: parseInt(formFields.shift),
          Position: formFields.position,
          MstStatusId: parseInt(formFields.status),
          MstPermissionId: formFields.permissiontype ? parseInt(formFields.permissiontype) : null,
          MstPermissiondurationId: formFields.permissionduration ? parseInt(formFields.permissionduration) : null,
          MInTime: buildDateTime(formFields.forenoonInTime),
          MOutTime: buildDateTime(formFields.forenoonOutTime),
          MRemarks: formFields.remarksForenoon || null,
          AInTime: buildDateTime(formFields.afternoonInTime),
          AOutTime: buildDateTime(formFields.afternoonOutTime),
          ARemarks: formFields.remarksAfternoon || null,
          Totalhours: formFields.totalHours ? parseFloat(formFields.totalHours) : null,
          CreatedBy: parseInt(createdBy, 10),
          Flag: flag,
        };
        const response = await IUDAPI(data, "AttendanceAPI/IUDAttendance");
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Attendance data inserted successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Attendance data insert failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Attendance data modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Attendance data modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
      }
    } else {
      const data = {
        mstAttendanceId: bindSalaryPaidGridDatas[rowIndex].MstAttendanceId,
        createdBy: createdBy,
        flag: flag,
      };

      const response = await IUDAPI(data, "AttendanceAPI/IUDAttendance");
      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Attendance data deleted successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Failed to delete Attendance data. 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Attendance data Inactivated successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Attendance data Inactivated failed 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Attendance data activated successfully! 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Attendance data activated failed! 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      }
    }
  };

  const handleEdit = (rowIndex) => {
    setRowIndex(rowIndex);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstAttendanceId(bindSalaryPaidGridDatas[rowIndex].MstAttendanceId);

    // Format the date to YYYY-MM-DD
    // const attendanceDate = bindSalaryPaidGridDatas[rowIndex].Date
    //   ? new Date(bindSalaryPaidGridDatas[rowIndex].Date).toISOString().split("T")[0]
    //   : "";

    // Format time fields to HH:mm
    const formatTime = (time) => {
      if (!time) return "";
      const date = new Date(time);
      return isNaN(date.getTime()) ? "" : date.toISOString().split("T")[1].slice(0, 5);
    };

    setFormFields({
      ...formFields,
      staffName: bindSalaryPaidGridDatas[rowIndex].MstStaffId || "",


      salaryDate: bindSalaryPaidGridDatas[rowIndex].Date?.split("T")[0],
      designation: bindSalaryPaidGridDatas[rowIndex].MstDesignationId
        ? bindSalaryPaidGridDatas[rowIndex].MstDesignationId.toString()
        : "",
      shift: bindSalaryPaidGridDatas[rowIndex].MstShiftId || "",
      status: bindSalaryPaidGridDatas[rowIndex].MstStatusId
        ? bindSalaryPaidGridDatas[rowIndex].MstStatusId.toString()
        : "",
      permissiontype: bindSalaryPaidGridDatas[rowIndex].MstPermissionId
        ? bindSalaryPaidGridDatas[rowIndex].MstPermissionId.toString()
        : "",
      permissionduration: bindSalaryPaidGridDatas[rowIndex].MstPermissiondurationId
        ? bindSalaryPaidGridDatas[rowIndex].MstPermissiondurationId.toString()
        : "",
      forenoonInTime: (bindSalaryPaidGridDatas[rowIndex].MInTime),
      position: bindSalaryPaidGridDatas[rowIndex].Position || "",
      forenoonOutTime: (bindSalaryPaidGridDatas[rowIndex].MOutTime),
      afternoonInTime: (bindSalaryPaidGridDatas[rowIndex].AInTime),
      afternoonOutTime: (bindSalaryPaidGridDatas[rowIndex].AOutTime),
      remarksForenoon: bindSalaryPaidGridDatas[rowIndex].MRemarks || "",
      remarksAfternoon: bindSalaryPaidGridDatas[rowIndex].ARemarks || "",
      totalHours: bindSalaryPaidGridDatas[rowIndex].Totalhours
        ? bindSalaryPaidGridDatas[rowIndex].Totalhours.toString()
        : "",
    });
  };

  const cancel = () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    setpopUpOpen(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setSubmitBtnDisabled(false);
    setIsLoading(false);
    BindAttendance();

    setFormFields({
      staffName: "",
      salaryDate: new Date().toISOString().split("T")[0],
      designation: "",
      status: "",
      permissiontype: "",
      permissionduration: "",
      forenoonInTime: "",
      forenoonOutTime: "",
      afternoonInTime: "",
      afternoonOutTime: "",
      remarksForenoon: "",
      remarksAfternoon: "",
      totalHours: "",
    });
    setFormFieldsError({
      staffNameError: "",
      salaryDateError: "",
      designationError: "",
      statusError: "",
      permissiontypeError: "",
      permissiondurationError: "",
      forenoonInTimeError: "",
      forenoonOutTimeError: "",
      afternoonInTimeError: "",
      afternoonOutTimeError: "",
      remarksForenoonError: "",
      remarksAfternoonError: "",
    });
  };

  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
  };


  const handleAttendance = (
    rowIndex, flag) => {
    setRowIndex(rowIndex);
    setpopUpOpen(true);


    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }






    setPopUpData(bindSalaryPaidGridDatas[rowIndex])
    setPopupDataDD({
      // idProofType,
      // position: Position,
      // shiftName,
      // bloodGroup: BloodGroup,
      // gender,
      // // cityBindDD,
      // // state,
      // // countryBindDD
    });

    // setSelectedRows([matchedSalaryIndex]);
    // setCheckBoxStatus([matchedSalaryIndex]);
    // setBindSalaryPayData(matchedSalaryIndex);
  };

  const handleDropdownBlur = (name, value) => {
    let error = "";
  
    if (!value) {
      error = `Select ${fieldLabels[name]}`;
    }
  
    setFormFieldsError((prevErrors) => ({
      ...prevErrors,
      [`${name}Error`]: error,
    }));
  };

  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const formatTimeForDisplay = (timeString) => {
    if (!timeString) return '';

    // Extract just the time part if it's a full datetime string
    const timePart = timeString.includes('T')
      ? timeString.split('T')[1]
      : timeString;

    // Remove seconds if present
    const [hours, minutes] = timePart.split(':');

    const hour = parseInt(hours, 10);
    const period = hour >= 12 ? 'PM' : 'AM';
    const hour12 = hour % 12 || 12;

    return `${hour12}:${minutes} ${period}`;
  };

   if(FormData.status !="Permission"){
     FormData.permissiontype=""
  FormData.permissionduration=""
  }


  return (
    <MainLayout pageName={"3"}>

      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (

        <GridPage
          title="Attendance"
          header={AttendanceHeader}
          records={bindSalaryPaidGridDatas.map(item => ({
            ...item,
            Date: formatDateForDisplay(item.Date),
            MInTime: formatTimeForDisplay(item.MInTime),
            MOutTime:formatTimeForDisplay(item.MOutTime),
            AInTime:formatTimeForDisplay(item.AInTime),
            AOutTime:formatTimeForDisplay(item.AOutTime)
          }))}
          blockView={true}
          handleEdit={handleEdit}
          handleAction={handleAttendance}
          showAdd={showAdd}
        />
      )}

      {visibleAdd && (
        <div className="flex flex-col w-full">
          <div className={mainTable.clientMasterMainAdd}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Attendance"
            />

            <div className={mainTable.addShadowScreen}>
              <div className={mainTable.mainContentScreen}>
                <form className={mainTable.formForClientMaster}>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 p-4 gap-4">
                    <InputText
                      inputType="date"
                      title="Date"
                      name="salaryDate"
                      classStar="text-red-500"
                      content={formFields.salaryDate}
                      controlFunc={handleInputChange}
                      controlFuncBlur={handleBlur}
                      errorMessage={formFieldsError.salaryDateError}
                      disabled={true}
                    />

                    <AutoDropDown
                      title="Staff"
                      name="staffName"
                      options={staffNameDD}
                      placeholder="Select"
                      selectedOption={staffNameDD.find(
                        (x) => x.value === formFields.staffName
                      )}
                      classStar="text-red-500"
                      Class="custom-class"
                      controlFunc={(value, e) => handleStaffChange(value, e)}
                      // controlFuncBlur={handleBlur}
                      controlFuncBlur={() =>
                        handleDropdownBlur("staffName", formFields.staffName)
                      }
                      errorMessage={formFieldsError.staffNameError}
                    />

                    <AutoDropDown
                      title="Shift"
                      name="shift"
                      placeholder="Select"
                      Class="custom-class"
                      options={shiftDD}
                      selectedOption={shiftDD.find(
                        (x) => x.value === formFields.shift
                      )}
                      classStar="text-red-500"
                      controlFunc={(value, e) =>
                        handleInputChange({
                          target: { name: e.name, value: value.value },
                        })
                      }
                      controlFuncBlur={handleBlur}
                      errorMessage={formFieldsError.shiftError}
                      // disabled={isDuplicate}
                      disabled={true}
                    />

<InputText
  inputType="text"
  title="Position"
  name="position"
  content={formFields.position}
  disabled={true}   // 👈 make it read-only
  classStar="text-red-500"
/>

                 <DropDown
  title="Status"
  name="status"
  options={statusOptions}
  selectedOption={formFields.status}
  controlFunc={(e) => {
    const selectedStatus = e.target.value;
    const selectedStatusLabel = statusOptions.find(
      (s) => s.value.toString() === selectedStatus
    )?.label.toLowerCase();

    setFormFields({
      ...formFields,
      status: selectedStatus,
      permissiontype: selectedStatusLabel === "permission" ? formFields.permissiontype : "",
      permissionduration: selectedStatusLabel === "permission" ? formFields.permissionduration : "",
    });
  }}
  controlFuncBlur={handleBlur}
  classStar="text-red-500"
  placeholder="Select Status"
  errorMessage={formFieldsError.statusError}
  disabled={isDuplicate}
/>


<DropDown
  title="Permission Type"
  name="permissiontype"
  options={permissionTypeOptions}
  selectedOption={formFields.permissiontype}
  controlFunc={(e) =>
    setFormFields({
      ...formFields,
      permissiontype: e.target.value,
    })
  }
  controlFuncBlur={handleBlur}
  classStar={
    statusOptions.find(
      (s) => s.value.toString() === formFields.status
    )?.label.toLowerCase() === "permission"
      ? "text-red-500"   // show red star only if status = Permission
      : ""
  }
  placeholder="Select Permission Type"
  errorMessage={formFieldsError.permissiontypeError}
  disabled={
    isDuplicate ||
    statusOptions.find((s) => s.value.toString() === formFields.status)?.label.toLowerCase() !== "permission"
  }
/>

<DropDown
  title="Permission Duration"
  name="permissionduration"
  options={permissiondurationOptions}
  selectedOption={formFields.permissionduration}
  controlFunc={(e) =>
    setFormFields({
      ...formFields,
      permissionduration: e.target.value,
    })
  }
  controlFuncBlur={handleBlur}
  classStar={
    statusOptions.find(
      (s) => s.value.toString() === formFields.status
    )?.label.toLowerCase() === "permission"
      ? "text-red-500"
      : ""
  }
  placeholder="Select Permission Duration"
  errorMessage={formFieldsError.permissiondurationError}
  disabled={
    isDuplicate ||
    statusOptions.find((s) => s.value.toString() === formFields.status)?.label.toLowerCase() !== "permission"
  }
/>
                  </div>

                  <div className="font-semibold px-4">Forenoon</div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-4 gap-4">
                    <InputText
                      inputType="time"
                      title="In Time"
                      name="forenoonInTime"
                      content={formFields.forenoonInTime}
                      controlFunc={handleInputChange}
                      controlFuncBlur={handleBlur}
                      classStar="text-red-500"
                      errorMessage={formFieldsError.forenoonInTimeError}
                      disabled={isDuplicate}
                      sessionType={formFields.sessionType}
                      
                    />
                    <InputText
                      inputType="time"
                      title="Out Time"
                      name="forenoonOutTime"
                      content={formFields.forenoonOutTime}
                      controlFunc={handleInputChange}
                      controlFuncBlur={handleBlur}
                      classStar="text-red-500"
                      errorMessage={formFieldsError.forenoonOutTimeError}
                      disabled={isDuplicate}
                    />
                    <InputText
                      inputType="text"
                      title="Remarks"
                      name="remarksForenoon"
                      content={formFields.remarksForenoon}
                      controlFunc={handleInputChange}
                      maxLength={45}
                      controlFuncBlur={handleBlur}
                      errorMessage={formFieldsError.remarksForenoonError}
                      disabled={isDuplicate}
                    />
                  </div>

                  <div className="font-semibold px-4">Afternoon</div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 p-4 gap-4">
                    <InputText
                      inputType="time"
                      title="In Time"
                      name="afternoonInTime"
                      content={formFields.afternoonInTime}
                      controlFunc={handleInputChange}
                      controlFuncBlur={handleBlur}
                      classStar="text-red-500"
                      errorMessage={formFieldsError.afternoonInTimeError}
                      disabled={isDuplicate}
                    />
                    <InputText
                      inputType="time"
                      title="Out Time"
                      name="afternoonOutTime"
                      content={formFields.afternoonOutTime}
                      controlFunc={handleInputChange}
                      controlFuncBlur={handleBlur}
                      classStar="text-red-500"
                      errorMessage={formFieldsError.afternoonOutTimeError}
                      disabled={isDuplicate}
                    />
                    <InputText
                      inputType="text"
                      title="Remarks"
                      name="remarksAfternoon"
                      content={formFields.remarksAfternoon}
                      controlFunc={handleInputChange}
                      controlFuncBlur={handleBlur}
                      errorMessage={formFieldsError.remarksAfternoonError}
                      disabled={isDuplicate}
                      maxLength={45}
                    />
                    <InputText
                      inputType="text"
                      title="Total Hours"
                      name="totalHours"
                      content={formFields.totalHours}
                      disabled={true}
                      classStar="text-red-500"
                    />
                  </div>
                </form>

                <Buttons
                  addScreenTitle={addScreenTitle}
                  updateScreenTitle={updateScreenTitle}
                  handleSubmit={handleSubmit}
                  cancel={cancel}
                  disabledBtn={submitBtnDisabled}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}

      <MainPopup popUpOpen={popUpOpen} setpopUpOpen={setpopUpOpen}>
        <div>
          <PopUpScreenTitle
            title="Attendance"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <Attendancepopup
            data={popUpData}
            staffNameDD={staffNameDD}
            shiftDD={shiftDD}
            designationOptions={designationOptions}
            statusOptions={statusOptions}
            permissionTypeOptions={permissionTypeOptions}
            permissiondurationOptions={permissiondurationOptions}
          />
        </div>
        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default Attendance;